import React, {useState} from "react";
import {useBusyContext} from "../contexts/busycontext";
import {Section} from "./grouping/Section";
import {Col, Row} from "react-bootstrap";
import {ButtonLoading} from "./ButtonLoading";
import Collapse from "react-bootstrap/Collapse";
import {DataListView} from "./grouping/DataListView";
import PropTypes, {any} from "prop-types";

MemberCoupling.propTypes = {
    members: PropTypes.array,
    itemEditing: PropTypes.shape({any}),
    onFileEditingChange: PropTypes.func,
    editItem: PropTypes.func
}

export function MemberCoupling(props) {
    const {members, itemEditing, editItem, onFileEditingChange, setTempObject} = props;
    const [openVoorzitter, setOpenVoorzitter] = useState(false);
    const [openPenningsMeesters, setOpenPenningsMeesters] = useState(false);
    const [openSecretaris, setOpenSecretaris] = useState(false);
    const [openRaadsleden, setOpenRaadsleden] = useState(false);

    const {setIsBusy} = useBusyContext();

    async function onItemVoorzitterClicked(item) {
        setIsBusy(true);
        const result = await editItem
        ({...itemEditing, voorzitters: [...itemEditing.voorzitters, {id: item.id}]});
        if (result) {
            onFileEditingChange(result);
            setTempObject(result);
        }
        setIsBusy(false);
    }

    async function onItemSecretarisClicked(item) {
        setIsBusy(true);
        const result = await editItem
        ({...itemEditing, secretarissen: [...itemEditing.secretarissen, {id: item.id}]});
        if (result) {
            onFileEditingChange(result);
            setTempObject(result);
        }
        setIsBusy(false);
    }

    async function onItemPenningsMeestersClicked(item) {
        setIsBusy(true);
        const result = await editItem
        ({...itemEditing, penningsMeesters: [...itemEditing.penningsMeesters, {id: item.id}]});
        if (result) {
            onFileEditingChange(result);
            setTempObject(result);
        }
        setIsBusy(false);
    }

    async function onItemRaadsledenClicked(item) {
        setIsBusy(true);
        const result = await editItem
        ({...itemEditing, raadsLeden: [...itemEditing.raadsLeden, {id: item.id}]});
        if (result) {
            onFileEditingChange(result);
setTempObject(result);
        }

        setIsBusy(false);
    }

    return <Section>
        <MemberCouplingControl title={"Voorzitter"}
                               open={openVoorzitter}
                               clubEditing={itemEditing}
                               fieldName={"voorzitters"}
                               onOpenChanged={setOpenVoorzitter}
                               onFileEditingChange={onFileEditingChange}
                               setTempObject={setTempObject}
                               members={members}
                               memberArray={itemEditing?.voorzitters ? itemEditing.voorzitters : []}
                               editClub={editItem}
                               onItemClicked={onItemVoorzitterClicked}/>
        <MemberCouplingControl title={"Secretaris"}
                               open={openSecretaris}
                               clubEditing={itemEditing}
                               fieldName={"secretarissen"}
                               onOpenChanged={setOpenSecretaris}
                               onFileEditingChange={onFileEditingChange}
                               setTempObject={setTempObject}
                               members={members}
                               memberArray={itemEditing?.secretarissen ? itemEditing.secretarissen : []}
                               editClub={editItem}
                               onItemClicked={onItemSecretarisClicked}/>
        <MemberCouplingControl title={"Pennings meester"}
                               open={openPenningsMeesters}
                               clubEditing={itemEditing}
                               fieldName={"penningsMeesters"}
                               onOpenChanged={setOpenPenningsMeesters}
                               onFileEditingChange={onFileEditingChange}
                               setTempObject={setTempObject}
                               members={members}
                               memberArray={itemEditing?.penningsMeesters ? itemEditing.penningsMeesters : []}
                               editClub={editItem}
                               onItemClicked={onItemPenningsMeestersClicked}/>
        <MemberCouplingControl title={"Raadsleden"}
                               open={openRaadsleden}
                               clubEditing={itemEditing}
                               fieldName={"raadsLeden"}
                               onOpenChanged={setOpenRaadsleden}
                               onFileEditingChange={onFileEditingChange}
                               setTempObject={setTempObject}
                               members={members}
                               memberArray={itemEditing?.raadsLeden ? itemEditing.raadsLeden : []}
                               editClub={editItem}
                               onItemClicked={onItemRaadsledenClicked}/>
    </Section>
}

function MemberCouplingControl(props) {
    const {
        title,
        fieldName,
        members,
        onItemClicked,
        open,
        onOpenChanged,
        clubEditing,
        editClub,
        onFileEditingChange,
        setTempObject
    } = props;
    const {busy} = useBusyContext();
    return <Section>
        <Col xs={12}
             className={'border border-1 border-black mt-2 mb-2 rounded-2 '}>
            <Row className={'g-0 px-2 rounded-2 '}>
                <Col xs={6} className={'mt-2'}> {title}:</Col>
                <Col xs={6} className={'text-end mt-2'}>  {open ?
                    <ButtonLoading title={'Verberg'} isLoading={busy} onClick={e => {
                        e.stopPropagation();
                        onOpenChanged(!open);
                    }}/> :
                    <ButtonLoading title={'Wijzig'} isLoading={busy} onClick={e => {
                        e.stopPropagation();
                        onOpenChanged(!open);
                    }}/>}</Col>

            </Row>
            <Col xs={12} className={"p-2"}>
                {clubEditing ? clubEditing[fieldName]?.length > 0 ?
                    clubEditing[fieldName]?.map((v, index) => <SelectedMemberItem fieldName={fieldName}
                                                                                  clubEditing={clubEditing}
                                                                                  onFileEditingChange={onFileEditingChange}
                                                                                  setTempObject={setTempObject}
                                                                                  editClub={editClub}
                                                                                  indexNr={index}
                                                                                  member={v}/>) : "Nog niet toegevoegd!" : ""}
            </Col>
            <Col xs={12} className={'mt-2 px-2'}>
                <Collapse in={open}>
                    <div>
                        Selecteer een lid als {title}:
                        <DataListView onItemEditChange={onItemClicked}
                                      header={[{title: "Lidnummer", fieldName: "lidNr"}, {
                                          title: "Naam",
                                          fieldName: "naam"
                                      }, {title: "Voornaam", fieldName: "voornaam"}, {
                                          title: "Club",
                                          fieldName: "clubNaam"
                                      }]}
                                      searchHeaders={[{title: "Lidnummer", fieldName: "lidNr"}, {
                                          title: "Naam",
                                          fieldName: "naam"
                                      }, {title: "Voornaam", fieldName: "voornaam"}, {
                                          title: "Club",
                                          fieldName: "clubNaam"
                                      }]}
                                      dataArray={members}/>
                    </div>
                </Collapse>
            </Col>
        </Col>

    </Section>
}

function SelectedMemberItem(props) {
    const {member, clubEditing, fieldName, editClub, onFileEditingChange, indexNr,setTempObject} = props;
    const {busy, setIsBusy} = useBusyContext();

    const even = indexNr % 2 === 0;
    const style = even ?
        {backgroundColor: 'ghostwhite'} : {backgroundColor: 'white'}

    async function removeMember() {
        setIsBusy(true);
        if (clubEditing) {
            let clubEditingNew = {...clubEditing}
            clubEditingNew[fieldName] = clubEditing[fieldName].filter(v => v.id !== member.id);
            const result = await editClub(clubEditingNew);
            if (result) {
                onFileEditingChange(result);
                setTempObject(result);
                console.log(result)
            }
        }
        setIsBusy(false);
    }

    return <Section style={style} className={"rounded-2 mb-1"}>
        <Col>
            <p className={'p-0 m-0'}><strong>Lidnummer: </strong>{member?.lidNr}</p>
        </Col>
        <Col>
            <p className={'p-0 m-0'}><strong>Naam: </strong>{member?.naam}</p>
        </Col>
        <Col>
            <p className={'p-0 m-0'}><strong>Voornaam: </strong>{member?.voornaam}</p>
        </Col>
        <Col>
            <p className={'p-0 m-0'}><strong>Stamnr: </strong>{member?.clubNr}</p>
        </Col>
        <Col>
            <p className={'p-0 m-0'}><strong>Sector: </strong>{member?.sector}</p>
        </Col>
        <Col className={'text-end'}>
            <ButtonLoading title={'Ontkoppel'} isLoading={busy} onClick={() => removeMember()}
                           className={"btn-sm btn-warning"}>Verwijder</ButtonLoading>
        </Col>
    </Section>
}